// extracted by mini-css-extract-plugin
export var avatarContainer = "_a2-0";
export var avatarTypingWave = "_a2-i";
export var gray = "_a2-f";
export var green = "_a2-c";
export var icon = "_a2-9";
export var image = "_a2-1";
export var lg = "_a2-6";
export var md = "_a2-5";
export var presenceDot = "_a2-b";
export var red = "_a2-d";
export var sm = "_a2-4";
export var status = "_a2-a";
export var typingDot = "_a2-h";
export var typingPill = "_a2-g";
export var xl = "_a2-7";
export var xs = "_a2-3";
export var xxl = "_a2-8";
export var xxs = "_a2-2";
export var yellow = "_a2-e";